<template>
    <div class="gridClass flex text-white my-8">
        <div class="min-h-[140px] w-full rounded-3xl text-lg flex flex-col lg:flex-row p-8" :class="isDarkBlueBg ? 'bg-blue-700' : isBlueBg ? 'bg-blue-500' : 'bg-white'">
            <div class="whitespace-nowrap flex justify-center flex-col items-center pb-6 lg:pb-0 lg:pe-6  border-b lg:border-b-0 lg:border-e border-white border-opacity-50">
                <div>
                    {{ data.title }}
                </div>
                <div class="opacity-20">
                    {{ data.subtitle }}
                </div>
            </div>
            <div class="pt-6 lg:pt-0 lg:ps-6 flex-grow flex justify-center items-center">
                <div>
                    {{ data.desc }}
                </div>
            </div>
        </div>
    </div>
</template>


<script setup>
    defineProps({
        data: Object,
        isDarkBlueBg: Boolean,
        isBlueBg: Boolean
    })
</script>